/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const exportTargetMappingDataSchema = z.object({
	id: z.string(),
	campaignId: z.string(),
	exportIntegration: z.object({
		id: z.string(),
		organisationId: z.string(),
		integrationConfiguration: z.object({
			id: z.string(),
			komboIntegrationId: z.string(),
			komboToolId: z.string(),
			toolLabel: z.string().nullable(),
			integrationType: z.union([z.literal('ATS'), z.literal('HRIS')]),
			createdAt: z.iso.datetime(),
			updatedAt: z.iso.datetime(),
		}),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
		deactivationScheduledFor: z.iso.datetime().nullable(),
		deactivatedAt: z.iso.datetime().nullable(),
	}).nullable(),
	externalId: z.string(),
	syncDisqualifiedCandidates: z.boolean(),
	createdAt: z.iso.datetime(),
	updatedAt: z.iso.datetime(),
})

export type ExportTargetMappingDataSchema = z.infer<typeof exportTargetMappingDataSchema>
